module.exports = __webpack_public_path__ + "img/SER-A-3-I.c1a230c5.png";